import {
    useInfiniteQuery,
    UseInfiniteQueryOptions,
} from '@tanstack/react-query';

const useDefaultInfiniteQuery = (options: UseInfiniteQueryOptions) => {
    const infiniteQuery = useInfiniteQuery({
        ...options,
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages) =>
            lastPage.next ? pages.length + 1 : undefined,
        select: data => {
            const flatData = data.pages.flatMap(page => page.results);
            const count = data.pages.at(-1)?.count;
            return { ...data, flatData, count };
        },
    });

    return infiniteQuery;
};

export default useDefaultInfiniteQuery;
